import ICONS from "../../../assets/Icons";

const IpAddressErrorPage = (props) => {
  return (
    <div className="flex md:items-center justify-center h-fit md:h-[100dvh]">
      <div
        className={
          "flex flex-col md:flex-row items-center bg-Blue-6 md:bg-Blue-4 rounded-none md:rounded-[30px] max-w-[1024px] lg:w-[1024px] w-full mx-0 lg:mx-5 md:mx-5 md:border md:border-custom-red"
        }
      >
        <div
          className={
            "bg-Blue-6  md:rounded-[30px] px-4 lg:px-10 lg:py-[30px] md:py-[30px] py-[30px] lg:w-[512px] md:w-1/2 h-[360px] md:h-[530px] w-full flex flex-col md:justify-center"
          }
        >
          <div className="flex flex-col md:justify-center lg:justify-start text-center text-text-primary lg:w-[100%]  px-2 md:p-0 md:h-[511px] lg:h-[425px] h-[280px]">
            <img
              src={ICONS?.UNABLE_TO_RETRIVE_IP}
              alt="bg_image"
              className="lg:w-[331px] lg:h-[262px] md:w-[240px] md:h-[190px] w-[196px] h-[170px] mx-auto"
            />

            <div className="block lg:mt-2.5 md:mt-3 mt-10">
              <h5 className="text-center text-xl font-semibold tracking-[0.5px]">
                Unable to retrieve IP address!
              </h5>

              <p className="text-center text-sm my-[15px] break-words whitespace-normal max-w-[90%] md:max-w-full">
                To ensure a secure and identifiable login, your IP address must
                be captured before any login or session-refresh request can
                begin
              </p>
              <div
                onClick={() => props?.handleFetch()}
                className="fixed left-0 bottom-0 md:relative w-full md:w-[200px] md:rounded-[10px] cursor-pointer h-[50px] md:h-[36px] bg-text-primary hover:bg-White-hover md:bg-Blue-8 md:hover:bg-Blue-8-hover md:mx-auto flex justify-center items-center text-sm md:text-xs font-semibold tracking-[0.5px] text-Blue-3 md:text-white"
              >
                Try again
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col justify-start rounded-t-[20px] bg-Blue-4 md:bg-transparent w-full  mb-[50px] md:mb-0  md:rounded-none text-center text-text-primary lg:w-[552px] md:w-1/2 px-[15px] pt-[20px] md:p-6 md:h-[511px] lg:h-[460px] h-fit">
          <div className="block lg:mt-2.5 md:mt-3 ">
            <h5 className="text-left text-text-primary text-font-md pb-[20px] font-semibold tracking-[0.5px]">
              Unable to retrieve IP address due to one of the following reasons:
            </h5>

            <ul
              className="text-sm md:max-h-[340px] overflow-y-scroll"
              style={{
                textAlign: "left",
                listStyleType: "disc",
                paddingLeft: "20px",
                lineHeight: "2",
                display: "flex",
                flexDirection: "column",
                rowGap: "20px",
              }}
            >
              <ol
                start={"1"}
                style={{ listStyleType: "decimal", lineHeight: "1" }}
              >
                <li className="font-semibold tracking-[0.5px] text-font-sm">
                  Privacy and Security Settings
                </li>
              </ol>
              <li>
                <li>
                  Browser or device settings may block access to IP-related
                  information.
                </li>
                <li>
                  VPNs or proxies can obscure or replace the real IP address.
                </li>
                <li>Privacy-focused browsers can limit or fake IP exposure.</li>
              </li>
              <ol
                start="2"
                style={{
                  listStyleType: "decimal",
                  lineHeight: "1",
                }}
              >
                <li className="font-semibold tracking-[0.5px] text-font-sm">
                  Network Configuration Issues
                </li>
              </ol>
              <li>
                <li>No internet connection or weak connectivity.</li>
                <li>
                  Firewall or security rules block outbound requests to services
                  that fetch IP.
                </li>
              </li>
              <ol
                start="3"
                style={{ listStyleType: "decimal", lineHeight: "1" }}
              >
                <li className="font-semibold tracking-[0.5px] text-font-sm">
                  JavaScript Errors or Disabled Scripts
                </li>
              </ol>
              <li>
                <li>
                  If using JavaScript to fetch IP on the frontend, errors or
                  script blockers can prevent execution.
                </li>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IpAddressErrorPage;
